<template>
  <div id="ag-grid-rebates-scheduler">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="rebates-scheduler custom-vs-tabs slot-border-top">
        <vs-tab label="Scheduled">
          <div class="tab-text">
            <Scheduled></Scheduled>
          </div>
        </vs-tab>

        <!-- <vs-tab label="Queued-Auto Renew">
          <div class="tab-text">
            <QueuedAutoRenew></QueuedAutoRenew>
          </div>
        </vs-tab>

        <vs-tab label="Queued-Custom Lists">
          <div class="tab-text">
            <QueuedCustomLists></QueuedCustomLists>
          </div>
        </vs-tab> -->
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import Scheduled from "@/components/ag-grid-tables/rebates/rebates-scheduler/Scheduled.vue";
import QueuedAutoRenew from "@/components/ag-grid-tables/rebates/rebates-scheduler/QueuedAutoRenew.vue";
import QueuedCustomLists from "@/components/ag-grid-tables/rebates/rebates-scheduler/QueuedCustomLists.vue";

export default {
    name: 'RebatesScheduler',
    components: {
        Scheduled,
        QueuedAutoRenew,
        QueuedCustomLists
    },
};
</script>